import React from "react";
import Logo from "../../Assets/img/footer-logo.png"
const Footer = () => {
  return (
    <footer id="contact" className="py-16 px-6" style={{ backgroundColor: "#1F2937" }}>
      <div className="max-w-6xl mx-auto">
        {/* Top Footer Sections */}
        <div className="grid md:grid-cols-5 gap-10 mb-10">
          {/* Company Info */}
          <div className="md:col-span-2">
            <h4 className="text-3xl font-bold mb-4" style={{ color: "#FF8C00" }}>
              <img src={Logo} alt="" />
            </h4>
            <p className="text-lg mb-6" style={{ color: "#E5E7EB" }}>
              Your partner in creating clean, beautiful, and inspiring spaces. Professional cleaning
              services you can trust.
            </p>
            <div className="space-y-3">
              <div className="flex items-center gap-3">
                <span className="text-2xl">📞</span>
                <span className="text-lg" style={{ color: "#E5E7EB" }}>
                  9999 999 999
                </span>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-2xl">📧</span>
                <span className="text-lg" style={{ color: "#E5E7EB" }}>
                  info@expresscleanslate.com
                </span>
              </div>
        
            </div>
          </div>

          {/* Services Links */}
          <div>
            <h5 className="font-bold text-xl mb-4" style={{ color: "#FFFFFF" }}>
              Services
            </h5>
            <ul className="space-y-2 text-lg" style={{ color: "#E5E7EB" }}>
              <li>
                <a href="#offerings" className="hover:underline">
                  Memoirs
                </a>
              </li>
              <li>
                <a href="#offerings" className="hover:underline">
                 Slambook
                </a>
              </li>
              <li>
                <a href="#offerings" className="hover:underline">
                  Personal Diary
                </a>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h5 className="font-bold text-xl mb-4" style={{ color: "#FFFFFF" }}>
              Company
            </h5>
            <ul className="space-y-2 text-lg" style={{ color: "#E5E7EB" }}>
              <li>
                <a href="#about" className="hover:underline">
                  About Us
                </a>
              </li>
              <li>
                <a href="#services" className="hover:underline">
                  Case Studies
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Careers
                </a>
              </li>
              <li>
                <a href="#contact" className="hover:underline">
                  Contact Us
                </a>
              </li>
              <li>
                <a href="#blog" className="hover:underline">
                  Blog
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Press
                </a>
              </li>
            </ul>
          </div>

          {/* Resources Links */}
          <div>
            <h5 className="font-bold text-xl mb-4" style={{ color: "#FFFFFF" }}>
              Resources
            </h5>
            <ul className="space-y-2 text-lg" style={{ color: "#E5E7EB" }}>
              <li>
                <a href="#" className="hover:underline">
                  Help Center
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="hover:underline">
                  Terms of Service
                </a>
              </li>
            
            </ul>
          </div>
        </div>

        {/* Social Media & Newsletter */}
        <div className="border-t border-b py-8 mb-8" style={{ borderColor: "#374151" }}>
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            {/* Social Media */}
            <div>
              <h5 className="font-bold text-xl mb-3" style={{ color: "#FFFFFF" }}>
                Follow Us
              </h5>
              <div className="flex gap-4">
                <a
                  href="#"
                  className="w-12 h-12 text-blue-600 rounded-full flex items-center justify-center text-2xl hover:opacity-80"
                  style={{ backgroundColor: "#FF8C00" }}
                >
                  <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path fillRule="evenodd" d="M13.135 6H15V3h-1.865a4.147 4.147 0 0 0-4.142 4.142V9H7v3h2v9.938h3V12h2.021l.592-3H12V6.591A.6.6 0 0 1 12.592 6h.543Z" clipRule="evenodd" /></svg>
                </a>
                <a
                  href="#"
                  className="w-12 h-12 rounded-full flex items-center justify-center text-2xl hover:opacity-80"
                  style={{ backgroundColor: "#FF8C00" }}
                >
                  <svg className="w-5 h-5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24"><path d="M13.795 10.533 20.68 2h-3.073l-5.255 6.517L7.69 2H1l7.806 10.91L1.47 22h3.074l5.705-7.07L15.31 22H22l-8.205-11.467Zm-2.38 2.95L9.97 11.464 4.36 3.627h2.31l4.528 6.317 1.443 2.02 6.018 8.409h-2.31l-4.934-6.89Z" /></svg>
                </a>
                <a
                  href="#"
                  className="w-12 h-12 rounded-full text-red-600 flex items-center justify-center text-2xl hover:opacity-80"
                  style={{ backgroundColor: "#FF8C00" }}
                >
                  <i className="fa-brands fa-instagram"></i>
                </a>
                <a
                  href="#"
                  className="w-12 h-12 rounded-full text-blue-600  flex items-center justify-center text-2xl hover:opacity-80"
                  style={{ backgroundColor: "#FF8C00" }}
                >
                  <i className="fa-brands fa-linkedin"></i>
                </a>
              </div>
            </div>

            {/* Newsletter */}
            <div className="text-center md:text-right">
              <h5 className="font-bold text-xl mb-3" style={{ color: "#FFFFFF" }}>
                Stay Updated
              </h5>
              <p className="text-lg mb-3" style={{ color: "#E5E7EB" }}>
                Get cleaning tips &amp; special offers
              </p>
              <a
                href="#"
                className="inline-block px-6 py-2 rounded-full font-semibold btn-hover"
                style={{ backgroundColor: "#FF8C00", color: "#FFFFFF" }}
              >
                Subscribe Now
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Footer */}
        <div
          className="flex flex-col md:flex-row items-center justify-between gap-4 text-lg"
          style={{ color: "#E5E7EB" }}
        >
          <p id="footer-text">© 2025 CleanSlate. All rights reserved.</p>
          <div className="flex gap-6">
            <a href="#" className="hover:underline">
              Privacy
            </a>
            <a href="#" className="hover:underline">
              Terms
            </a>
            <a href="#" className="hover:underline">
              Cookies
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
